import { combineReducers } from "redux";

import configurationReducer from "./configuration";
import entityReducer from "./entity";
import flowReducer from "./flow";
import formReducer from "./form";
import systemMessageReducer from "./systemMessage";
import certificationTestResultReducer from "./certificationTestResult";

const reducers = combineReducers({
  configurations: configurationReducer,
  forms: formReducer,
  flows: flowReducer,
  entities: entityReducer,
  systemMessages: systemMessageReducer,
  certificationTestResult: certificationTestResultReducer,
});

export default reducers;
